export const exitEditableContentEditor = () => {
  const wasOpenedByAnotherWindow =
    typeof window.opener !== "undefined" && window.opener !== null;

  if (wasOpenedByAnotherWindow) {
    try {
      window.close();
      return;
    } catch {}
  }

  // This editor is designed to be saved on completion, as each edit is versioned in the db.
  // If auto-close is blocked, show explicit instruction so operators can complete the flow.
  const overlay = document.createElement("div");
  overlay.style.position = "fixed";
  overlay.style.top = "0";
  overlay.style.left = "0";
  overlay.style.width = "100%";
  overlay.style.height = "100%";
  // eslint-disable-next-line no-inline-colors/no-inline-colors -- This DOM-only fallback overlay is outside the React theme system.
  overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
  overlay.style.zIndex = "1000";

  const text = document.createElement("p");
  text.style.position = "absolute";
  text.style.top = "50%";
  text.style.left = "50%";
  text.style.transform = "translate(-50%, -50%)";
  text.style.color = "white";
  text.style.fontSize = "2rem";
  text.style.fontWeight = "bold";
  text.textContent = "Please close this window to return to the app.";
  overlay.appendChild(text);
  document.body.appendChild(overlay);
};
